module.exports = __webpack_public_path__ + "img/perfection.7f48e06.jpg";